import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  IconButton,
  Typography,
} from "@suraasa/placebo-ui"
import MainImage from "assets/Onboarding/home/main.webp"
import { Xmark } from "iconoir-react"

const GetStarted = ({
  open,
  handleContinue,
  handleClose,
}: {
  open: boolean
  handleContinue: () => void
  handleClose?: () => void
}) => {
  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="rounded-2xl">
        {handleClose && (
          <DialogClose className="absolute right-2 top-2">
            <IconButton color="black">
              <Xmark />
            </IconButton>
          </DialogClose>
        )}
        <div className="flex flex-col">
          <div className="h-[213px] w-full  sm:h-[274px]">
            <img
              src={MainImage}
              alt="main-img"
              className="size-full rounded-t-2xl object-cover"
            />
          </div>
          <div className="p-3">
            <Typography variant="title2" className="mb-1.5">
              Let&apos;s Show You Around!
            </Typography>
            <Typography variant="largeBody" className="mb-5 text-onSurface-500">
              Take a quick tour to explore what you can do on Suraasa.
            </Typography>
            <Button
              color="black"
              onClick={handleContinue}
              className="ml-auto flex"
              autoFocus
            >
              Start the Tour
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default GetStarted
